import { useQuery } from '@tanstack/react-query';
import { getLearningPath } from '@/services/learningApi';
import { queryKeys } from '@/lib/queryKeys';
import PageLoading from '@/components/common/PageLoading';
import ContentApiErrorState from '@/components/common/ContentErrorState';
import EmptyState from '@/components/common/EmptyState';

export default function LearningPage() {
  const {
    data: path,
    isLoading,
    isError,
    error: pathError,
    refetch,
  } = useQuery({
    queryKey: queryKeys.learning.path,
    queryFn: getLearningPath,
    retry: 1,
  });

  if (isLoading) {
    return <PageLoading message='学习路径加载中…' />;
  }

  return (
    <div className='max-w-[980px] mx-auto px-6 py-12'>
      <h1
        className='font-semibold text-apple-near-black mb-2'
        style={{ fontSize: '2rem', lineHeight: 1.1, letterSpacing: '-0.02em' }}
      >
        学习路径
      </h1>
      <p className='text-apple-gray mb-10' style={{ fontSize: '0.9375rem' }}>
        按模块系统学习 Python，从入门到进阶。
      </p>

      {isError ? (
        <div className='mb-8'>
          <ContentApiErrorState error={pathError} onRetry={() => void refetch()} />
        </div>
      ) : null}

      {!isError && !path?.modules?.length ? (
        <EmptyState title='暂无学习路径' description='完成诊断题后会生成个性化学习路径。' />
      ) : null}

      <div className='space-y-4'>
        {path?.modules?.map((module, index) => (
          <div key={module.id} className='bg-white rounded-2xl p-6 shadow-card-sm'>
            <div className='flex items-center justify-between mb-4'>
              <div className='flex items-center gap-4'>
                <span className='w-8 h-8 rounded-full bg-apple-blue text-white flex items-center justify-center text-[0.8125rem] font-semibold shrink-0'>
                  {index + 1}
                </span>
                <h3
                  className='font-medium text-apple-near-black'
                  style={{ fontSize: '1.0625rem', lineHeight: 1.4 }}
                >
                  {module.title}
                </h3>
              </div>
              <span className='text-apple-gray text-[0.875rem] shrink-0'>{module.progress}%</span>
            </div>
            {/* Progress bar */}
            <div className='w-full bg-apple-light-gray rounded-full h-1.5 ml-12'>
              <div
                className='bg-apple-blue h-1.5 rounded-full transition-all duration-500'
                style={{ width: `${module.progress}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
